module.exports = __webpack_public_path__ + "static/img/splash.25d8f44.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/splash.jpeg
// module id = rcGi
// module chunks = 1